import React from "react";

export const DisclaimerContext = React.createContext();

const initialState =
  {
    id : [],
  }


const DisclaimerReducer = (state, action) => {

    switch (action.type) {
        case "SET_DISCLAIMER":
          if(state.id.includes(action.payload)) return state
        return {
          ...state, id: [...state.id, action.payload]
      }
        default: return
    }
}


export const DisclaimerProvider = props => {
    const [state, dispatch] = React.useReducer(DisclaimerReducer, initialState);
    const value = { state, dispatch };

    return (
        <DisclaimerContext.Provider value={value}>
            {props.children}
        </DisclaimerContext.Provider>
    );
}

export const SET_DISCLAIMER = "SET_DISCLAIMER"
